import React from 'react';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header'

class Content_7 extends React.Component {
    render() {
        const {data = {}, eid} = this.props;
        const { moreLocal, iconMore } = data;
        const tr = (
            <tr height="18">
                <td width="8"><img src="/images/homepage/style/style1/esymbol_wev8.gif" alt=""/></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(387821,"Gmail Labs推出搜索自动完成功能")}</font></a></td>
                <td width="100" align="right"><font className="font">{getLabel(387822,"曾东平")}</font></td>
            </tr>
        );
        const tr2 = (
            <tr className="sparator" height="1px">
                <td colSpan="3"/>
            </tr>
        );

        return (
            <div className="item" id={`item_${eid}`}>
                <Header data={data} eid={eid}/>
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="tab2">
                            <table height="32" cellSpacing="0" cellPadding="0">
                                <tr>
                                    <td className="tab2selected" style={{width:'84px'}}>{getLabel(83663,"聚焦新闻")}</td>
                                    <td className="tab2unselected" style={{width:'84px'}}>{getLabel(83669,"行业聚焦")}</td>
                                    <td className="tab2unselected" style={{width:'84px'}}>{getLabel(83670,"媒体视点")}</td>
                                </tr>
                            </table>
                        </div>
                        <table width="100%">
                            {tr}{tr2}{tr}{tr2}{tr}{tr2}{tr}{tr2}{tr}
                        </table>
                    </div>
                    <div className="footer" id={`footer_${eid}`} style={{textAlign: 'right'}}>
                        {moreLocal == 'footer' ? <a href="javascript:;"><img src={iconMore} alt=""/></a> : ''}
                    </div>
                </div>
            </div>
        );
    }
}

export default Content_7;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_7.js